import React, { Component } from "react";
import EditForm from "../forms/EditForm";
import axios from "axios";
import values from "lodash/values";
import {
  Grid,
  Card,
  Message,
  Header,
  List,
  Icon,
  Button,
  Dropdown,
  Form,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { getEntityRelationsList } from "../../actions/relationsActions";
import EditEntityForm from "../forms/EditEntityForm";
import EntityUserForm from "../forms/EntityUserForm";

import { getAllPractitioners } from "../../actions/auth";
import EntityUserList from "../lists/EntityUsersList";
import { Right } from "react-bootstrap/lib/Media";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iconAndName: {
    display: "flex",
    alignItems: "center",
  },
  nameAndInfo: {
    display: "flex",
    flexDirection: "column",
  },
  info: {
    color: "rgba(0,0,0,.4)",
  },
};
const approvedOptions = [
  { key: 1, text: "Aprobada", value: 1 },
  { key: 2, text: "No aprobada", value: 0 },
];
class EditEntityPage extends Component {
  state = {
    updated: false,
    registered: false,
    data: {
      medico_id: "",
      institucion_id: this.props.id,
      aprobada: "",
    },
    entityUsers: [],
    relations: [],
  };

  onChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  onSelectChange = (e, { name, value }) => {
    this.setState({ data: { ...this.state.data, [name]: value } });
  };

  submit = (data) => {
    axios
      .post("/api/entities/updateEntity", {
        data,
      })
      .then((resp) => {
        // console.log("updated");
        this.setState({
          updated: true,
        });
        setTimeout(() => {
          this.setState({
            updated: false,
          });
        }, 1000);
      });
  };

  submitEntityUser = (data) => {
    data.id_ext = this.props.id;
    axios
      .post("/api/entityUsers/addEntityUser", {
        data,
      })
      .then((resp) => {
        if (resp.data.registered) {
          //Si está registrado
          this.setState({ registered: resp.data.registered });
        } else {
          this.setState({
            updated: true,
          });
          axios
            .get(`/api/entities/entityUsers/${this.props.id}`)
            .then((res) => this.setState({ entityUsers: res.data.resp }));
          setTimeout(() => {
            this.setState({
              updated: false,
            });
          }, 1000);
        }
      });
  };

  handleAdd = () => {
    axios
      .post(`/api/relations/addRelation/`, { data: this.state.data })
      .then((res) =>
        axios
          .get(`/api/relations/relationsByEntity/${this.props.id}`)
          .then((res) => this.setState({ relations: res.data.resp }))
      );
  };

  handleDelete = (data) => {
    axios
      .delete(
        `/api/relations/deleteRelation/${data.medico_id}/${this.props.id}`
      )
      .then((res) =>
        axios
          .get(`/api/relations/relationsByEntity/${this.props.id}`)
          .then((res) => this.setState({ relations: res.data.resp }))
      );
  };

  handleDeleteEntityUser = (id) => {
    axios
      .delete(`/api/entityUsers/delete/${id}`)
      .then((res) =>
        axios
          .get(`/api/entities/entityUsers/${this.props.id}`)
          .then((res) => this.setState({ entityUsers: res.data.resp }))
      );
  };

  handleApproveEntityUser = (e, data) => {
    // console.log(e.target.value, data.name);
    axios
      .post(`/api/entityUsers/approveEntityUser`, {
        data: { id: data.name, approved: data.checked },
      })
      .then((res) =>
        axios
          .get(`/api/entities/entityUsers/${this.props.id}`)
          .then((res) => this.setState({ entityUsers: res.data.resp }))
      );

    // const practitioners = this.props.practitioners.map(practitioner => {
    //   if (practitioner.practitioner_id === data.name) {
    //     practitioner.approved = data.checked === true ? 1 : 0;
    //     axios.post("/api/practitioners/approvePractitioner", {
    //       data: {
    //         approved: practitioner.approved,
    //         practitioner_id: practitioner.practitioner_id,
    //         loggedPractitioner: this.props.loggedPractitioner
    //       }
    //     });
    //   }
    //   return practitioner;
    // });
    // this.setState({
    //   practitioners: practitioners
    // });
  };

  componentDidMount() {
    axios
      .get(`/api/relations/relationsByEntity/${this.props.id}`)
      .then((res) => this.setState({ relations: res.data.resp }));
    axios
      .get(`/api/entities/entityUsers/${this.props.id}`)
      .then((res) => this.setState({ entityUsers: res.data.resp }));
    this.props.getAllPractitioners({ role: this.props.role });
  }
  render() {
    const { updated, relations, entityUsers } = this.state;
    // console.log(entityUsers);
    const practitionerOptions = values(this.props.allPractitioners).map(
      (pract, index) => ({
        key: pract.id,
        text: pract.fullname,
        value: pract.username,
      })
    );

    const entitiesOptions = values(this.props.allEntities).map(
      (ent, index) => ({
        key: ent.id,
        text: ent.nombre,
        value: ent.id,
      })
    );

    let relationsItems = [];
    if (relations.length > 0) {
      relationsItems = relations.map((e, index) => (
        <List.Item key={index}>
          <List.Content verticalAlign="middle">
            <div style={styles.listItem}>
              <div style={styles.iconAndName}>
                <Icon size="big" color="teal" name="user md" />
                <div style={styles.nameAndInfo}>
                  {" "}
                  {`${e.names} ${e.lastnames} - ${e.nombre_institucion}`}
                </div>
              </div>
              <div>
                <Button
                  icon="trash"
                  color="red"
                  onClick={() => this.handleDelete({ medico_id: e.medico_id })}
                ></Button>
              </div>
            </div>
          </List.Content>
        </List.Item>
      ));
    }

    const {
      activo,
      ciudad,
      direccion,
      email,
      id,
      nit,
      nombre,
      telefono,
      role,
      loggedPractitioner,
    } = this.props;
    return (
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          {updated ? (
            <Message color="green">
              <Header size="medium" textAlign="center">
                Guardado
              </Header>
            </Message>
          ) : null}
          <Card fluid={true}>
            <Message attached>
              <Header size="medium">Editar: {this.props.nombre}</Header>
            </Message>

            <Card.Content>
              <EditEntityForm
                submit={this.submit}
                cancel={this.props.showEntitiesList}
                activo={activo}
                ciudad={ciudad}
                direccion={direccion}
                email={email}
                id={id}
                nit={nit}
                nombre={nombre}
                telefono={telefono}
                role={role}
                loggedPractitioner={loggedPractitioner}
              />
            </Card.Content>
          </Card>
          <Card fluid>
            <Message attached>
              <Header size="medium">Agregar ususario institucional</Header>
            </Message>

            <Card.Content>
              <EntityUserForm
                submit={this.submitEntityUser}
                registered={this.state.registered}
                role={role}
                loggedPractitioner={loggedPractitioner}
              />
            </Card.Content>
          </Card>

          <Message attached>
            <Header size="medium">Lista de usuarios institucionales</Header>
          </Message>

          <EntityUserList
            entityUsers={entityUsers}
            handleDeleteEntityUser={this.handleDeleteEntityUser}
            handleApproveEntityUser={this.handleApproveEntityUser}
          />

          <Card fluid={true}>
            <Message attached>
              <Header size="medium">Asociar medicos a esta institución</Header>
            </Message>
            <Card.Content>
              <Form>
                <Form.Group inline widths="equal">
                  <Form.Select
                    fluid
                    options={practitionerOptions}
                    placeholder="Selecione un perfil"
                    deburr
                    name="medico_id"
                    search
                    onChange={this.onSelectChange}
                  />
                  {/* <Form.Select
                    fluid
                    options={entitiesOptions}
                    placeholder="Selecione una institución"
                    deburr
                    name="institucion_id"
                    search
                    onChange={this.onSelectChange}
                  /> */}
                  <Form.Select
                    fluid
                    options={approvedOptions}
                    placeholder="Selecione una opción"
                    deburr
                    name="aprobada"
                    search
                    onChange={this.onSelectChange}
                  />
                </Form.Group>
                <Button
                  type="Button"
                  color="blue"
                  icon="save"
                  content="Guardar"
                  floated="right"
                  labelPosition="right"
                  onClick={this.handleAdd}
                />
              </Form>
              {relationsItems.length > 0 ? (
                <List divided selection>
                  {relationsItems}
                </List>
              ) : null}
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  const { activo, ciudad, direccion, email, id, nit, nombre, telefono } =
    state.entityInfo.resp;

  const { role, practitioner_id } = state.practitioner.resp;
  const { allPractitionersStore, allEntitiesStore } = state;

  return {
    activo,
    ciudad,
    direccion,
    email,
    id,
    nit,
    nombre,
    telefono,
    allPractitioners: allPractitionersStore,
    allEntities: allEntitiesStore,
    role,
    loggedPractitioner: practitioner_id,
  };
};

export default connect(mapStateToProps, {
  getEntityRelationsList,
  getAllPractitioners,
})(EditEntityPage);
